import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ExportExcelServiceService } from '@shared/exportar-excel/export-excel-service.service';
import { ErrorModel } from '@shared/models/ErrorModel';
import { filtrosReporteMovimientosDTO } from '@shared/models/stock/FiltrosReporteMovimientosDTO';

import { MessageService } from '@shell/message.service';
import { TransaccionesService } from '@stock/transacciones.service';
import { DatePipe } from "@angular/common";

@Component({
  selector: 'app-modal-exportar-movimientos',
  templateUrl: './modal-exportar-movimientos.component.html',
  styleUrl: './modal-exportar-movimientos.component.scss'
})
export class ModalExportarMovimientosComponent {

  @Input() movimientos: filtrosReporteMovimientosDTO;
  @Input() fechaDesde: string
  @Input() fechaHasta: string;
  @Input() enableExportRecarga: boolean;
  @Input() enableExportRecepcion: boolean;
  movimientosRecargaReporte: any[] = [];
  movimientosRecepcionReporte: any[] = [];

  exportandoRecargas: boolean = false;
  exportandoRecepciones: boolean = false;

  constructor(
    private messageService: MessageService,
    private datePipe: DatePipe,
    private transaccionesService : TransaccionesService,
    public activeModal: NgbActiveModal,
    private excelService: ExportExcelServiceService
    ) {}

   //llamadas al service
  exportarRecargas(){
    this.exportandoRecargas = true;
    this.transaccionesService.putMovimientosRecargas(this.movimientos)
      .subscribe(result => {
          this.movimientosRecargaReporte = result;
          //modifico propiedad fechaHora para presentarla en el excel
          this.movimientosRecargaReporte = this.movimientosRecargaReporte.map(mov => ({
            ...mov,
            Fecha_Hora: this.datePipe.transform(mov.Fecha_Hora, 'dd/MM/yyyy HH:mm a')
          }));
          this.exportandoRecargas = false;
          this.generarExcel(this.movimientosRecargaReporte, 'Recargas');
          this.messageService.showSuccessMessage("Se generó el excel de recargas.")
        },
        (error: ErrorModel) => {
          this.exportandoRecargas = false;
          this.generarExcel(this.movimientosRecargaReporte, 'Recargas');
          this.messageService.showErrorMessage("Error al exportar excel recargas. \n" + error.description);
        })
  }

  exportarRecepciones() {
    this.exportandoRecepciones = true;
    this.transaccionesService.putMovimientosRecepciones(this.movimientos)
      .subscribe(result => {
          this.movimientosRecepcionReporte = result;
          //modifico propiedades para presentarlas en el excel
          this.movimientosRecepcionReporte = this.movimientosRecepcionReporte.map(mov => ({
            ...mov,
            Fecha_Hora: this.datePipe.transform(mov.Fecha_Hora, 'dd/MM/yyyy HH:mm a'),
            Cuit_Transportista: mov.Cuit_Transportista.replace(/-/g, ''),
            Porcentaje_Diferencia: mov.Porcentaje_Diferencia + '%'
          }));
          this.exportandoRecepciones = false;
          this.generarExcel(this.movimientosRecepcionReporte, 'Recepciones');
          this.messageService.showSuccessMessage("Se generó el excel de recepciones.")
        },
        (error: ErrorModel) => {
          this.exportandoRecepciones = false;
          this.messageService.showErrorMessage("Error al exportar excel recepciones. \n" + error.description);
        })
  }

  generarExcel(movimientosReporte: any[], op: string) {
    // armar el formato
    this.excelService.exportAsExcelFile(movimientosReporte, `${this.movimientos.codigoAeroplanta}_${op.toUpperCase()}_${this.datePipe.transform(this.movimientos.fechaDesde, 'dd-MM-yyyy')}al${this.datePipe.transform(this.movimientos.fechaHasta, 'dd-MM-yyyy')}`);
  }
}
